import React, { useEffect, useRef, useState } from "react";
import "./home.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import {
  bannerData,
  commiteData,
  coverFlowData,
  keyStrengthData,
  servicesData,
} from "../../data/data";
import {
  grid10_img,
  grid1_img,
  grid2_img,
  grid3_img,
  grid4_img,
  grid5_img,
  grid6_img,
  grid7_img,
  grid8_img,
  grid9_img,
  accBg,
  keyStrengthBg,
  unlocking,
  whiteRightArrow,
  unlockingMb,
  keyStrengthBgMb,
  greyRightArrow,
} from "../../source";
import Services from "../../components/Services/Services";
import { CustomAccordion } from "../../components/Accordion/Accordion";
import KeyStrength from "../../components/KeyStrength/KeyStrength";
import { useWindowSize } from "react-use";
import OurCommitment from "../../components/OurCommitment/OurCommitment";
import { useNavigate } from "react-router-dom";
import { homeURL } from "../../helpers/paths";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";

const Home = () => {
  const { width } = useWindowSize();
  const [activeIndex, setActiveIndex] = useState(0);
  const [isMarginLeft, setIsMarginLeft] = useState();
  const [isActiveAcc, setIsActiveAcc] = useState(0);
  const [activeButton, setActiveButton] = useState(2);

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const navigate = useNavigate();

  const handleClick = (buttonId) => {
    setActiveButton(buttonId);
  };

  const weServe_card_mobData = [
    {
      id: 1,
      img: grid1_img,
      heading: "Electronics",
    },
    {
      id: 2,
      img: grid2_img,
      heading: "Automotive",
    },
    {
      id: 3,
      img: grid3_img,
      heading: "Pharmaceuticals",
    },
    {
      id: 4,
      img: grid4_img,
      heading: "Retail & E-commerce",
    },
    {
      id: 5,
      img: grid5_img,
      heading: "Industrial Equipment",
    },
    {
      id: 6,
      img: grid6_img,
      heading: "Consumer Goods",
    },
    {
      id: 7,
      img: grid7_img,
      heading: "Oil and Gas",
    },
    {
      id: 8,
      img: grid9_img,
      heading: "Hazardous Handling & Packing",
    },
    {
      id: 9,
      img: grid10_img,
      heading: "AOG Support 24/7",
    },
    {
      id: 10,
      img: grid8_img,
      heading: "Others",
    },
  ];

  const bannerList = bannerData.map((banner, index) => (
    <SwiperSlide key={`banner-${index}`}>
      <div className="banner_data">
        <img
          src={width <= 767 && banner.imgMb ? banner.imgMb : banner.img}
          alt={banner.title}
          width={1920}
          height={1080}
          className="banner_img"
        />
        <div className="my_container">
          <div className="banner_content">
            <h2
              className="title"
              dangerouslySetInnerHTML={{ __html: banner.title }}
            ></h2>
            <p
              className="banner_desc"
              dangerouslySetInnerHTML={{ __html: banner.desc }}
            ></p>
          </div>
        </div>
      </div>
    </SwiperSlide>
  ));

  const coverFlowList = coverFlowData.map((item, i) => (
    <SwiperSlide key={`coverflow-${i}`}>
      <div className="img_wrapper" data-aos="fade-up">
        <img
          src={item.img}
          alt=""
          width={536}
          height={650}
          className="cover_img"
        />
      </div>
    </SwiperSlide>
  ));

  const coverFlowContent = coverFlowData.map((item, i) => (
    <div
      className={`content_wrapper order-md-1 ${
        activeIndex === i ? "active" : ""
      }`}
      key={i}
    >
      <div className="data_wrapper" data-aos="fade-up">
        <h2
          className="section_title36"
          dangerouslySetInnerHTML={{ __html: item.title }}
        ></h2>
        <p className="section_desc">{item.desc}</p>
      </div>
      <div className="nav_wrapper">
        {/* <h3 className="big_title">{item.id < 10 ? `0${item.id}` : item.id}</h3> */}
        <h3 className="big_title">
          {activeIndex < 10 ? `0${activeIndex + 1}` : activeIndex + 1}
        </h3>
        <div className="arrow_container">
          <div className="arrow_wrapper left_arrow_wrapper">
            <img
              src={whiteRightArrow}
              alt="right arrow"
              className="left_arrow"
            />
          </div>
          <div className="arrow_wrapper right_arrow_wrapper">
            <img
              src={whiteRightArrow}
              alt="right arrow"
              className="right_arrow"
            />
          </div>
        </div>
      </div>
    </div>
  ));

  // const handleAccordionChange = (index) => {
  //   setIsActiveAcc(index); // Update active accordion index
  // };

  const adjustMargins = () => {
    const windowsize = window.innerWidth;
    const secwidth = document.querySelector(".my_container").offsetWidth;
    const calcwidth = windowsize - secwidth;

    if (secwidth) {
      setIsMarginLeft(calcwidth / 2);
    }
  };

  useEffect(() => {
    adjustMargins();
    // Adjust margins when window resizes
    const handleResize = () => adjustMargins();
    window.addEventListener("resize", handleResize);
    // Adjust margins on window load
    window.addEventListener("load", handleResize);
    // Clean up event listeners when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("load", adjustMargins);
    };
  }, []);

  useEffect(() => {
    const handleScrollToHash = () => {
      const hash = window.location.hash;

      if (hash) {
        const targetId = hash.substring(1);
        const targetSection = document.getElementById(targetId);

        if (targetSection) {
          const offset = width > 767 ? 80 : 55; // Gap from viewport top
          const targetPosition =
            targetSection.getBoundingClientRect().top + window.scrollY - offset;

          // Smooth scroll to the target section
          window.scrollTo({
            top: targetPosition,
            behavior: "smooth",
          });
          navigate(homeURL, { replace: true });
          console.log(`Scrolling to: ${targetId}`);
        } else {
          console.warn(`Element with id "${targetId}" not found.`);
        }
      } else {
        window.scrollTo(0, 0); // Scroll to the top if no hash
      }
    };

    const handleLinkClick = (event) => {
      const anchor = event.target.closest("a[href^='#']");
      if (anchor) {
        event.preventDefault(); // Prevent the browser's default jump behavior
        const hash = anchor.getAttribute("href");
        if (hash) {
          // Update the URL hash manually
          window.history.pushState(null, "", hash);
          handleScrollToHash();
        }
      }
    };

    // Initial scroll on mount
    handleScrollToHash();

    // Add event listeners
    document.body.addEventListener("click", handleLinkClick);

    // Cleanup event listeners
    return () => {
      document.body.removeEventListener("click", handleLinkClick);
    };
  }, [navigate]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <MetaDecorator
        canonicalLink={window.location.href}
        metaTitle="Protrans"
        metaDesc="Welcome to Protrans"
      />

      <section className="home_sec1" data-aos="fade">
        <div className="banner_container">
          <Swiper slidesPerView={1} modules={[Autoplay]}>
            {bannerList}
          </Swiper>
        </div>
      </section>

      <section className="home_sec2" id="about">
        <div className="my_container">
          <div className="content_wrapper" data-aos="fade-up">
            <h2 className="section_title">
              DELIVERING <span>EXCELLENCE</span> IN LOGISTICS – ABOUT PROTRANS
              LOGISTICS FZCO
            </h2>
            <p className="section_desc">
              Protrans Logistics FZCO, established in 2024, is a Dubai-based
              freight forwarding and logistics company. We offer comprehensive
              solutions for global trade, focusing on efficiency and customer
              satisfaction. Our strategic location in the Dubai Airport Freezone
              enables us to provide world-class services.
            </p>
            <div className="img_wrapper" data-aos="fade-up">
              <img
                src={width > 767 ? unlocking : unlockingMb}
                alt="unlockin"
                width={1641}
                height={538}
                className="logistic_img"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="home_sec3">
        <div className="my_container">
          <OurCommitment />
        </div>
      </section>

      <section className="home_sec4" id="services">
        <div className="my_container">
          <h2 className="section_title" data-aos="fade-up">
            COMPREHENSIVE LOGISTICS <span>SERVICES</span>
          </h2>
        </div>

        <Services servicesData={servicesData} />
      </section>

      <section className="home_sec5" id="third-party">
        <div
          className="full_width_container"
          style={{ marginLeft: `${width > 1023 && isMarginLeft - 4}px` }}
        >
          <h2 className="section_title" data-aos="fade-up">
            Third-Party Logistics (3PL) <br /> <span>EXCELLENCE</span>
          </h2>
          <div className="coverflow_container">
            <div className="cover_slider_wrapper order-md-2">
              <Swiper
                slidesPerView={1.725}
                spaceBetween={10}
                loop={true}
                // centeredSlides={true}
                // slideToClickedSlide={true}
                modules={[Navigation]}
                navigation={{
                  nextEl: ".right_arrow_wrapper",
                  prevEl: ".left_arrow_wrapper",
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                  },
                  768: {
                    slidesPerView: 1.05,
                  },
                  993: {
                    slidesPerView: 1.22,
                  },
                  1200: {
                    slidesPerView: 1.22,
                  },
                }}
                // onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
                onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
              >
                {coverFlowList}
                {/* <SwiperSlide key="blank-slide">
                  <div className="img_wrapper"></div>
                </SwiperSlide> */}
              </Swiper>
            </div>
            {coverFlowContent}
            {/* <div className={`content_wrapper`}></div> */}
          </div>
        </div>
      </section>

      <section className="home_sec6" id="key-strength">
        <div className="my_container">
          <h2 className="section_title" data-aos="fade-up">
            OUR KEY <span>STRENGTHS</span>
          </h2>
          <KeyStrength
            bgImg={width > 600 ? keyStrengthBg : keyStrengthBgMb}
            keyData={keyStrengthData}
          />
        </div>
      </section>

      {/* INDUSTRIES WE SERVE section */}
      <section className="home_serve" id="industries">
        {/* for desktop */}
        <div className="my_container weServeDesk">
          <div className="row">
            <div className="col-12 heading_serve_col" data-aos="fade-up">
              <div className="main_heading_serve">
                <span style={{ color: "#04B6D4", fontStyle: "italic" }}>
                  INDUSTRIES
                </span>{" "}
                WE SERVE
              </div>
            </div>
            <div className="col-12 conten_serve_col" data-aos="fade-up">
              <div className="main_conten_serve">
                Protrans Logistics FZCO specializes in serving diverse
                industries with expertise in handling even the most challenging
                logistics needs. From managing dangerous goods with precision
                and compliance to offering a dedicated 24/7 desk for AOG
                (Aircraft on Ground) solutions, we ensure reliability and
                efficiency. Whether supporting e-commerce, pharmaceuticals,
                automotive, or electronics, our tailored solutions empower
                businesses to meet their supply chain goals seamlessly..
              </div>
            </div>
          </div>

          <div className="row grid_serve_row">
            <div className="col-12 col_img_grid_12">
              <div className="row ">
                <div
                  className="col-md-3 col_img_grid_3"
                  data-aos="fade-up"
                  data-aos-delay={100}
                >
                  <div className="img_grid_wrapper">
                    <img src={grid1_img} alt="img" className="grid_img" />
                  </div>
                  <div className="content_heading">Electronics</div>
                </div>
                <div
                  className="col-md-3 col_img_grid_3"
                  data-aos="fade-up"
                  data-aos-delay={200}
                >
                  <div className="img_grid_wrapper">
                    <img src={grid2_img} alt="img" className="grid_img" />
                  </div>
                  <div className="content_heading">Automotive</div>
                </div>
                <div
                  className="col-md-3 col_img_grid_3"
                  data-aos="fade-up"
                  data-aos-delay={300}
                >
                  <div className="img_grid_wrapper">
                    <img src={grid3_img} alt="img" className="grid_img" />
                  </div>
                  <div className="content_heading">Pharmaceuticals</div>
                </div>
                <div
                  className="col-md-3 col_img_grid_3"
                  data-aos="fade-up"
                  data-aos-delay={400}
                >
                  <div className="img_grid_wrapper">
                    <img src={grid4_img} alt="img" className="grid_img" />
                  </div>
                  <div className="content_heading">
                    Retail & <br /> E-commerce
                  </div>
                </div>
                <div
                  className="col-md-3 col_img_grid_3"
                  data-aos="fade-up"
                  data-aos-delay={100}
                >
                  <div className="img_grid_wrapper">
                    <img src={grid5_img} alt="img" className="grid_img" />
                  </div>
                  <div className="content_heading">
                    Industrial <br /> Equipment
                  </div>
                </div>
                <div
                  className="col-md-3 col_img_grid_3"
                  data-aos="fade-up"
                  data-aos-delay={200}
                >
                  <div className="img_grid_wrapper">
                    <img src={grid6_img} alt="img" className="grid_img" />
                  </div>
                  <div className="content_heading">Consumer Goods</div>
                </div>
                <div
                  className="col-md-3 col_img_grid_3"
                  data-aos="fade-up"
                  data-aos-delay={300}
                >
                  <div className="img_grid_wrapper">
                    <img src={grid7_img} alt="img" className="grid_img" />
                  </div>
                  <div className="content_heading">Oil and Gas</div>
                </div>
                <div
                  className="col-md-3 col_img_grid_3"
                  data-aos="fade-up"
                  data-aos-delay={400}
                >
                  <div className="img_grid_wrapper">
                    <img src={grid9_img} alt="img" className="grid_img" />
                  </div>
                  <div className="content_heading">
                    Hazardous Handling <br /> & Packing
                  </div>
                </div>
                <div
                  className="col-md-3 col_img_grid_3"
                  data-aos="fade-up"
                  data-aos-delay={100}
                >
                  <div className="img_grid_wrapper">
                    <img src={grid10_img} alt="img" className="grid_img" />
                  </div>
                  <div className="content_heading">AOG Support 24/7</div>
                </div>
                <div
                  className="col-md-3 col_img_grid_3"
                  data-aos="fade-up"
                  data-aos-delay={200}
                >
                  <div className="img_grid_wrapper">
                    <img src={grid8_img} alt="img" className="grid_img" />
                  </div>
                  <div className="content_heading">Others</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* for mobile */}
        {/* INDUSTRIES WE SERVE section Mobile Section*/}
        <div className="my_container weServeMob">
          <div className="row">
            <div className="col-12 heading_serve_col" data-aos="fade-up">
              <div className="main_heading_serve">
                <span style={{ color: "#04B6D4", fontStyle: "italic" }}>
                  INDUSTRIES
                </span>{" "}
                WE SERVE
              </div>
            </div>
            <div
              className="col-12 conten_serve_col conten_serve_col_mob"
              data-aos="fade-up"
            >
              <div className="main_conten_serve">
                Protrans Logistics FZCO specializes in serving diverse
                industries with expertise in handling even the most challenging
                logistics needs. From managing dangerous goods with precision
                and compliance to offering a dedicated 24/7 desk for AOG
                (Aircraft on Ground) solutions, we ensure reliability and
                efficiency. Whether supporting e-commerce, pharmaceuticals,
                automotive, or electronics, our tailored solutions empower
                businesses to meet their supply chain goals seamlessly..
              </div>
            </div>
          </div>
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={50} // Space between slides
            slidesPerView={1} // Number of slides visible
            // autoplay={{ delay: 3000 }}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              500: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              576: {
                slidesPerView: 2,
                spaceBetween: 30,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 40,
              },
            }}
            loop={true} // Enable looping
          >
            {/* Swiper slides */}
            {weServe_card_mobData.map((data) => {
              return (
                <SwiperSlide key={data.id}>
                  <div className="weServe_card_mob" data-aos="fade-up">
                    <img src={data.img} alt="img" className="slider_mob_img" />
                    <div className="weServe_heading_mob">{data.heading}</div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
          {/* Custom Navigation Buttons */}
          <div className="weServe_custom_btns" data-aos="fade-up">
            <button
              ref={prevRef}
              className={`weServe_custom_prev_btn  ${
                activeButton === 1 ? "active" : ""
              }`}
              onClick={() => handleClick(1)}
            >
              {activeButton === 1 ? (
                <img
                  src={whiteRightArrow}
                  alt="icon"
                  className="weSreve_arrow right_serve_arr"
                />
              ) : (
                <img
                  src={greyRightArrow}
                  alt="icon"
                  className={"weSreve_arrow right_serve_arr"}
                />
              )}
            </button>
            <button
              ref={nextRef}
              className={`weServe_custom_next_btn  ${
                activeButton === 2 ? "active" : ""
              }`}
              onClick={() => handleClick(2)}
            >
              {activeButton === 2 ? (
                <img
                  src={whiteRightArrow}
                  alt="icon"
                  className="weSreve_arrow"
                />
              ) : (
                <img
                  src={greyRightArrow}
                  alt="icon"
                  className={"weSreve_arrow "}
                />
              )}
              {/* <img src={whiteRightArrow} alt="icon" className="weSreve_arrow" /> */}
            </button>
          </div>
        </div>
      </section>

      <section className="home_sec8" id="commitment">
        <div className="row commite_row">
          <div className="col-lg-6 commite_col" data-aos="fade-up">
            {commiteData?.map((item, i) => (
              <div
                className={`commite_img_wrapper ${
                  isActiveAcc === i ? "active" : ""
                }`}
                key={`Acc-${i}`}
              >
                <img
                  src={width <= 991 && item.imgMb ? item.imgMb : item.img}
                  alt={item.title}
                  width={width > 991 ? 960 : 375}
                  height={width > 991 ? 960 : 389}
                  className="commite_img"
                />
              </div>
            ))}
          </div>
          <div
            className="col-lg-6 commite_col"
            data-aos="fade-up"
            data-aos-delay={width > 991 ? 200 : ""}
          >
            <div className="commite_acc_wrapper">
              <h2 className="section_title">
                OUR COMMITMENT TO <span>SUSTAINABILITY</span>
              </h2>
              <CustomAccordion
                firstActive
                items={commiteData}
                // onAccordionChange={handleAccordionChange}
              />
              <img src={accBg} alt="background" className="bg_img" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
